import React from 'react'
import { List, Typography, Tooltip } from 'antd'
import { RiseOutlined, DashboardOutlined } from '@ant-design/icons'

interface Events {
    maxNoOfConcurrentViewers: number,
    eventName: string,
    totalNoOfViewers: number
}

const PAGE_SIZE = 10

const EventList = ({ events }: { events: Events[] }) => {
    if (!events) {
        events = []
    }
    console.log("event list :: ", events)
    return (
        <List
            itemLayout="vertical"
            size="large"
            pagination={events.length > PAGE_SIZE ? {
                pageSize: PAGE_SIZE,
            } : false}
            dataSource={events}
            renderItem={item => (
                <List.Item
                    key={item.eventName}
                    style={{ fontSize: 16 }}
                    extra={
                        <div style={{ display: 'flex' }}>
                            <div style={{ padding: "0 10px", minWidth: "70px", cursor: "default" }}>
                                <Tooltip title="Max number of concurrent viewers during the event">
                                    <RiseOutlined /> {item.maxNoOfConcurrentViewers || 0}
                                </Tooltip>
                            </div>
                            <div style={{ padding: "0 10px", minWidth: "70px", cursor: "default" }}>
                                <Tooltip title="Total number of viewers for the event">
                                    <DashboardOutlined /> {item.totalNoOfViewers || 0}
                                </Tooltip>
                            </div>
                        </div>
                    }
                >
                    <Typography.Text>{item.eventName}</Typography.Text>
                </List.Item>
            )}
        />
    )
}

export default EventList;